import React, { Fragment, useState, useEffect } from 'react';

import { Picky } from 'react-picky';
import '../assets/css/Picky.scss';
import '../assets/css/SearchFilterContent.scss';
import history from '../history';

//components
import ServicesSearch from '../services/ServicesSearch';
import CheckBoxFilter from './CheckBoxFilter';

//Redux
import {getParams} from '../store/params/reducer';
import {resetParams} from '../store/params/action';
import updateParams from '../store/params/action';
import {connect} from 'react-redux';

const SearchFilterContent = ({
  setSearch,
  setLoc,
  showFilters,
  setShowFilters,
  params,
  updateParams,
  resetParams
}) => {

  let paymentDefaults = [
    {
      order: 0,
      value: '',
      name: 'Todos',
      selected: false,
      id: 'all',
    },
    {
      order: 1,
      value: 'Efectivo',
      name: 'Efectivo',
      selected: params.filters.paymentMethodCash,
      id: 'paymentMethodCash',
    },
    {
      order: 2,
      value: 'Tarjeta de crédito/débito',
      name: 'Tarjeta de crédito/débito',
      selected: params.filters.paymentMethodCreditDebitCard,
      id: 'paymentMethodCreditDebitCard',
    },
    {
      order: 3,
      value: 'Transferencias',
      name: 'Transferencias',
      selected: params.filters.paymentMethodTransfers,
      id: 'paymentMethodTransfers',
    },
  ];

  let deliveryDefaults = [
    {
      order: 0,
      value: '',
      name: 'Todos',
      selected: false,
      id: 'all',
    },
    {
      order: 1,
      value: 'Con envío a domicilio',
      name: 'Con envío a domicilio',
      selected: params.filters.shipingProducts,
      id: 'shipingProducts',
    },
    {
      order: 2,
      value: 'Con retiro en tienda',
      name: 'Con retiro en tienda',
      selected: params.filters.pickup,
      id: 'pickup',
    },
  ];

  let specialDefaults = [
    {
      order: 1,
      value: 'Lideradas por mujeres',
      name: 'Lideradas por mujeres',
      selected: params.filters.womanPyme,
      id: 'womanPyme',
    },{
      order: 2,
      value: 'Cooperativas',
      name: 'Cooperativas',
      selected: params.filters.cooperative,
      id: 'cooperative',
    }
  ];

  const [catPicky, setCatPicky] = useState([]);
  const [subCatPicky, setSubCatPicky] = useState([]);
  const [selectedSubCatPicky, setSelectedSubCatPicky] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [mediosPago, setMediosPago] = useState(paymentDefaults);
  const [despacho, setDespacho] = useState(deliveryDefaults);
  const [categoriasEspeciales, setCategoriasEspeciales] = useState(specialDefaults);

  const getCategories = () => {
    ServicesSearch.getDataCategories()
      .then((response) => {
        let scOrdered = response.data['CatSubCategorias'].options.sort((a, b) => {
          return a.name.localeCompare(b.name)
        });
        setAllSubCategories(scOrdered);
        setCatPicky(()=>{
          return response.data['Categorias'].options.map((category, index)=>{
            return category.name;
          }).sort();
        });
        if(params.selectedCategory.length>0){
          let subcats = params.selectedCategory.length>0 ? filterAndOrderCats(params.selectedCategory, scOrdered) : [];
          setSubCatPicky(subcats);
          if(params.selectedSubCategories.length>0){
            setSelectedSubCatPicky(params.selectedSubCategories);
            // console.log(params.selectedSubCategories);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const filterAndOrderCats = (categoriesSelectedArray, subcategories) => {
    let resp = [];
    let sorted = typeof subcategories !== "undefined" ? subcategories : allSubCategories;
    categoriesSelectedArray.sort().forEach((category, index) => {
      let val = `main-${index}-${category}`;
      resp.push(val);

      let sub = sorted.filter((subcategory) => {
        return subcategory.catname===category;
      }).map((scat, i) => `sec-${index}-${scat.name}`);

      resp.push(...sub);
    });
    return resp;
  }

  const handleSelectedCategories = (value) => {
    let subcats = value.length>0 ? filterAndOrderCats(value) : [];
    let subcategories = params.subcategories;
    if(params.categories.length>value.length){
      setSelectedSubCatPicky([]);
      subcategories = [];
    }
    updateParams({
      ...params,
      subcategories: subcategories,
      selectedSubCategories: selectedSubCatPicky,
      limit:18,
      from:0,
      categories: value,
      selectedCategory: value
    })
    setSubCatPicky(subcats);
  };

  const handleSelectedSubCategories = (value) => {
    setSelectedSubCatPicky(value);
    updateParams({
      ...params,
      limit:18,
      from:0,
      subcategories: value.map((selected) => displayName(selected)),
      selectedSubCategories: value
    })
  };

  const clearSearchFilters = (e) => {
    e.preventDefault();
    resetParams();
    setMediosPago(setSelectedToFalse(paymentDefaults));
    setDespacho(setSelectedToFalse(deliveryDefaults));
    setCategoriasEspeciales(setSelectedToFalse(specialDefaults));
    setSearch({
      query: '',
      location: '',
      defaultLocation: ''
    });
    setLoc('');
    history.push('search');
  }

  const setSelectedToFalse = (array) => {
    return array.map((arr, index)=>{
      arr.selected = false;
      return arr;
    });
  };

  const validateIfMain = (value) => {
    return value.split("-")[0]==="main" ? true : false;
  };

  const displayName = (value) => {
    return value.split("-")[2];
  };

  useEffect(getCategories, []);

  return (
    <Fragment>
    {
      showFilters ?
      <Fragment>
        <div>
          <div className="row pt-4 px-0">
            <div className="col-auto col-md-5 px-0" style={{fontSize:'1.25rem'}}><strong>Filtros</strong></div>
            <div className="col-auto col-md-7" style={{margin:'auto'}}><a className="clear-filters-a" href="" onClick={(e)=>clearSearchFilters(e)}>Eliminar filtros</a></div>
          </div>
        </div>
        <div>
          <div className="pt-1 categories-title">Categorías</div>
          <p className="grey-txt">Selecciona una o más categorías</p>
          <Picky
            numberDisplayed={0}
            manySelectedPlaceholder={"%s categoría(s)"}
            id="picky"
            options={catPicky}
            value={params.selectedCategory}
            multiple={true}
            onChange={handleSelectedCategories}
            dropdownHeight={210}
            placeholder={'Todas'}
            render={({
              style,
              isSelected,
              item,
              selectValue,
              labelKey,
              valueKey,
              multiple,
            }) => {
              return (
                <div key={item + new Date().getTime()}>
                  <li
                    style={style}
                    className={isSelected ? 'selected' : ''}
                    key={item}
                    onClick={() => selectValue(item)}
                  >
                    <label className="container">{item}
                      <input
                        type="checkbox"
                        checked={isSelected}
                        readOnly
                        />
                      <span className="checkmark"></span>
                    </label>
                  </li>
                </div>
              );
            }}
          />

        </div>

        <div>
          <div className="pt-2 categories-title">Sub categorías</div>
          <p className="grey-txt">Selecciona una o más sub categorías</p>
          <Picky
            numberDisplayed={0}
            manySelectedPlaceholder={"%s sub categoría(s)"}
            id="picky-subcategories"
            options={subCatPicky}
            value={selectedSubCatPicky}
            multiple={true}
            onChange={handleSelectedSubCategories}
            dropdownHeight={210}
            placeholder={'Todas'}
            render={({
              style,
              isSelected,
              item,
              selectValue,
              labelKey,
              valueKey,
              multiple,
            }) => {
              return (
                <div key={item + new Date().getTime()}>
                {
                  validateIfMain(item) ?
                  <li
                   disabled
                   >
                   <strong>{displayName(item)}</strong>
                  </li>
                  :
                  <li
                    style={style}
                    className={isSelected ? 'selected' : ''}
                    key={item[valueKey]}
                    onClick={() => selectValue(item) }
                  >
                    <label className="container">{displayName(item)}
                      <input
                        type="checkbox"
                        checked={isSelected}
                        readOnly
                        />
                      <span className="checkmark"></span>
                    </label>
                  </li>
                }
                </div>
              );
            }}
          />
        </div>

        <div>
          <div className="pt-2 categories-title">Métodos de pago</div>
          {mediosPago.map((mPago, index) => (
            <CheckBoxFilter
              key={index}
              data={mPago}
              dataArr={mediosPago}
              setDataArr={setMediosPago}
              i={index}
              type={"paymentMethods"}
            />
          ))}
        </div>

        <div>
          <div className="pt-2 categories-title">Despacho </div>
          {despacho.map((delivery, index) => (
            <CheckBoxFilter
              key={index}
              data={delivery}
              dataArr={despacho}
              setDataArr={setDespacho}
              i={index}
              type={"deliveryMethods"}
            />
          ))}
        </div>

        <div>
          <div className="pt-2 categories-title">Categorías especiales</div>
          {categoriasEspeciales.map((special, index) => (
            <CheckBoxFilter
              key={index}
              data={special}
              dataArr={categoriasEspeciales}
              setDataArr={setCategoriasEspeciales}
              i={index}
              type={"specialCategories"}
            />
          ))}
        </div>
      </Fragment>
      :
      null
    }
    </Fragment>
  );
};

const mapStateToProps = state => {
  return {
    params: getParams(state)
  };
};

export default connect(mapStateToProps, {updateParams, resetParams})(SearchFilterContent);
